/** Stable keys for case listing columns (must match telerad-api ListingColumnPreferences::Service). */
export const ListingColumnKey = {
  TAGS: "tags",
  PATIENT_ID: "patient_id",
  PATIENT_NAME: "patient_name",
  PATIENT_AGE: "patient_age",
  PATIENT_GENDER: "patient_gender",
  STUDY: "study",
  REFERRING_DOCTOR: "referring_doctor",
  PATIENT_HISTORY: "patient_history",
  SCAN_CENTER: "scan_center",
  STUDY_DATE: "study_date",
  UPLOADED_DATE: "uploaded_date",
  ASSIGNED_DOCTOR: "assigned_doctor",
  REPORTED_DOCTOR: "reported_doctor",
  TIME_ELAPSED: "time_elapsed",
  TAT: "tat",
  REPORTED_TIME: "reported_time",
  STATUS: "status",
  CASE_STATUS: "case_status",
  UPLOAD_STATUS: "upload_status",
  ACTIONS: "actions",
} as const;

export type ListingColumnKeyType = (typeof ListingColumnKey)[keyof typeof ListingColumnKey];

export interface ListingColumnPreferenceRow {
  key: string;
  visible: boolean;
  width: number;
}

export const LISTING_CONTEXT = {
  ADMIN_CASES: "admin_cases",
  DOCTOR_CASES: "doctor_cases",
  SCAN_CENTER_CASES: "scan_center_cases",
} as const;

/** Admin cases table: same three columns as `fixed: "left"` on wide screens — locked in the column picker. */
export const ADMIN_CASES_LOCKED_COLUMN_ORDER: readonly string[] = [
  ListingColumnKey.TAGS,
  ListingColumnKey.PATIENT_ID,
  ListingColumnKey.PATIENT_NAME,
];

/** Default width for the Actions column (icon buttons; can be resized above the minimum). */
export const DEFAULT_ACTIONS_COLUMN_WIDTH = 350;

/** Minimum width for Actions — enough for a typical row of icon-only controls. */
export const ACTIONS_COLUMN_MIN_WIDTH = 350;

/** Scan Center case list: narrower actions toolbar default and floor (fewer actions than admin/doctor). */
export const SCAN_CENTER_DEFAULT_ACTIONS_COLUMN_WIDTH = 200;
export const SCAN_CENTER_ACTIONS_COLUMN_MIN_WIDTH = 200;

/** Most data columns — matches listing preference validation on the API side. */
export const DEFAULT_LISTING_DATA_COLUMN_MIN_WIDTH = 100;

/** Tags column (color dots) — narrower minimum than text columns. */
export const TAGS_LISTING_COLUMN_MIN_WIDTH = 50;

/** Resize / persist floor per column key (actions min is per-context). */
export function minWidthForListingColumnKey(
  key: string,
  actionsMin: number = ACTIONS_COLUMN_MIN_WIDTH
): number {
  if (key === ListingColumnKey.ACTIONS) return actionsMin;
  if (key === ListingColumnKey.TAGS) return TAGS_LISTING_COLUMN_MIN_WIDTH;
  return DEFAULT_LISTING_DATA_COLUMN_MIN_WIDTH;
}
